import React from "react";
import { Grid } from "@mui/material";
import { message } from "antd";
import { useWidth } from "../../../../../libs/hooks";
import {
  malimaxOneCount,
  malimaxTwoCount,
  malimaxThreeCount,
} from "../../../../../libs/apis";
import { CardComponent } from "./card-component";
import { CardWelcomeComponent } from "./card-welcome";
import { TableComponent } from "./table-component";
import { PeriodFilter } from "./period-filter";

/** Dashboard con los procesos de Malimax filtrados por periodo (hoy por defecto). */
export const MalimaxDashboard = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [period, setPeriod] = React.useState("hoy");
  const [totalOne, setTotalOne] = React.useState(0);
  const [totalTwo, setTotalTwo] = React.useState(0);
  const [totalThree, setTotalThree] = React.useState(0);
  const [typeProcess, setTypeProcess] = React.useState("all");

  const periodLabel =
    options.find((el) => el.value === period)?.label ?? "Hoy";

  React.useEffect(() => {
    const load = async () => {
      try {
        const [one, two, three] = await Promise.all([
          malimaxOneCount(period),
          malimaxTwoCount(period),
          malimaxThreeCount(period),
        ]);
        setTotalOne(one.data?.total ?? 0);
        setTotalTwo(two.data?.total ?? 0);
        setTotalThree(three.data?.total ?? 0);
      } catch (err: any) {
        message.error(err.toString());
      }
    };
    load();
  }, [period]);

  const changeTypeProcess = (value: string) => {
    setTypeProcess(value === typeProcess ? "all" : value);
  };

  const cards = [
    { title: "Proceso 1", quantity: totalOne, color: "tomato" },
    { title: "Proceso 2", quantity: totalTwo, color: "orange" },
    { title: "Proceso 3", quantity: totalThree, color: "green" },
  ];

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignContent="flex-start"
      alignItems="center"
      sx={{ px: { xs: 1, sm: 2 } }}
    >
      <Grid item xs={12}>
        <PeriodFilter options={options} value={period} onChange={setPeriod} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <CardWelcomeComponent />
      </Grid>
      {cards.map((card) => (
        <Grid item xs={6} sm={2.5} key={card.title}>
          <CardComponent
            width={width}
            title={card.title}
            quantity={card.quantity}
            handleUpdate={() => undefined}
            options={options}
            color={card.color}
            value={periodLabel}
            typeProcess={typeProcess}
            changeTypeProcess={changeTypeProcess}
            hidePeriod
          />
        </Grid>
      ))}
      <Grid item xs={12}>
        <TableComponent typeProcess={typeProcess} period={period} />
      </Grid>
    </Grid>
  );
};
